// extracted by mini-css-extract-plugin
module.exports = {"body":"EditTagsModal_body__2mwQC","saveButton":"EditTagsModal_saveButton__1gtUQ"};